import React from 'react';
import { styled } from '@compiled/react';
import { Modal } from '@atlaskit/onboarding';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { useHasSeenReport } from '../../services/has-seen-report/index.tsx';
import welcomeImage from './assets/deployment-frequency-welcome.svg';
import messages from './messages.tsx';

const WelcomeMessage = () => {
	const { formatMessage } = useIntl();
	const [hasSeenReport, setHasSeenReportToTrue] = useHasSeenReport();
	if (hasSeenReport) return null;
	return (
		<Modal
			actions={[
				{
					onClick: () => {
						setHasSeenReportToTrue();
					},
					text: formatMessage(messages.gotIt),
				},
			]}
			heading={formatMessage(messages.heading)}
			image={welcomeImage}
		>
			<p>{formatMessage(messages.firstParagraph)}</p>
			<List>
				<li>{formatMessage(messages.point1)}</li>
				<li>{formatMessage(messages.point2)}</li>
			</List>
			<p>{formatMessage(messages.lastParagraph)}</p>
		</Modal>
	);
};

export default WelcomeMessage;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const List = styled.ul({
	marginLeft: token('space.200', '16px'),
	textAlign: 'left',
});
